import { __assign } from "tslib";
import { useSelector } from 'react-redux';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { getBiContentViewStatus } from '../../DeviationPage/redux/selectors';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../types/deviation';
/** Returns correct click BI events for deviation links.
 * Please do not piggyback for other event types */
export function useBiDataForDeviationLink(deviation, extraData) {
    var _a;
    var contentViewStatus = useSelector(function (state) { return deviation && getBiContentViewStatus(state, deviation); });
    var _b = useSubscriptionTier(deviation), needsSubscription = _b.needsSubscription, isSubscribedButBlocked = _b.isSubscribedButBlocked;
    if (!deviation) {
        return undefined;
    }
    var typeid = getDeviationResourceType(deviation);
    var itemid = deviation.deviationId;
    var creatorid = (_a = deviation.author) === null || _a === void 0 ? void 0 : _a.useridUuid;
    if (typeid === DeviationResourceType.TIER) {
        return getBiDataForTierLink(deviation, extraData);
    }
    return BiData(__assign(__assign({ sectionid: BiContextProvidedValue, sectionname: BiContextProvidedValue, section_typeid: BiContextProvidedValue, sectiontype: BiContextProvidedValue, sectionrank: BiContextProvidedValue, widgetname: BiContextProvidedValue, rank: BiContextProvidedValue, sort_type: BiContextProvidedValue, reason_shown: BiContextProvidedValue }, extraData), { evid: 100, typeid: typeid, itemid: itemid, creatorid: creatorid, content_view_status: needsSubscription || isSubscribedButBlocked
            ? 'subscription_locked'
            : contentViewStatus }));
}
export function getBiDataForTierLink(deviation, extraData) {
    if (!deviation) {
        return undefined;
    }
    var typeid = getDeviationResourceType(deviation);
    var itemid = deviation.deviationId;
    return BiData(__assign(__assign({ sectionid: BiContextProvidedValue, sectionname: BiContextProvidedValue, section_typeid: BiContextProvidedValue, sectiontype: BiContextProvidedValue, sectionrank: BiContextProvidedValue, rank: BiContextProvidedValue }, extraData), { evid: 545, typeid: typeid, itemid: itemid }));
}
//# sourceMappingURL=useBiDataForDeviationLink.js.map